{
	let masks=[[8073,'7057277124788','433471280','583931461667','7356568830132'],
	[7953,'7057277124788','1628420931619','583931461667','433471280'],
	[8001,'7057277124788','1628420931619','583966523427','15687894008153'],
	[7969,'7057277124788','7356568830132','583934541859','6283572164'],
	[12153,'7057277124788','7356568830132','583966523427','1628420931619'],
	[11905,'7057277124788','433459684','583925694499','1628420931619'],
	[8577,'7057277124788','1628420931619','583966523427','433459684'],
	[8074,'7057277124788','433471280','583931461667','433459684'],
	[7954,'7057277124788','5072105924','583931461667','433471280'],
	[7970,'7057277124788','1628420931619','583934541859','452536872'],
	[8002,'7057277124788','1628420931619','583966523427','15687894008153'],
	[12162,'7057277124788','5072105924','583925694499','433459684'],
	[12058,'7057277124788','5072105924','583931461667','433459684'],
	[12066,'7057277124788','433459684','583934541859','1628420931619'],
	[12098,'7057277124788','5072044420','583966523427','1628420931619'],
	[8076,'7057277124788','433471280','583925694499','5072085956'],
	[7956,'7057277124788','433471280','583931461667','433471280'],
	[7972,'7057277124788','433471280','583934541859','433459684'],
	[8004,'7057277124788','15687894008153','583966523427','433459684'],
	[8588,'7057277124788','5072105924','583925694499','5072085956'],
	[11916,'7057277124788','5072085956','583925694499','5072044420'],
	[12052,'7057277124788','5072105924','583931461667','5072085956'],
	[12068,'7057277124788','5072105924','583934541859','433459684'],
	[12100,'7057277124788','5072044420','583966523427','433459684']];
	let names = {'583966523427': 'Beta Glucan',
	'15687894008153': 'Clear & Soothe Set',
	'7356568830132': 'Graceful Mama nurturing oil',
	'583925694499': 'Coconut',
	'7057277124788': 'Oatmeal Soap',
	'5072044420': 'Skin Balm',
	'5072085956': 'Skin Butter',
	'433471280': 'Skin Cream',
	'5072105924': 'Skin Glow',
	'452536872': 'Skin Glow + Mist',
	'6283572164': 'Skin Mist',
	'1628420931619': 'Skin Silk',
	'433459684': 'Skin Velvet',
	'583934541859': 'Spruce Sprout',
	'583931461667': 'Cocoa'
	};
	function radioClick() {
		document.getElementById('B'+this.name.substr(1)).disabled = false;
	}
	function addToCart() {
		var variantId = this.dataVariant;
		fetch('/cart/add.js', {
			  body: JSON.stringify({ id: variantId, quantity: 1 }),
			  credentials: 'same-origin',
			  method: 'POST',
			  headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest' 
			  }
			}).then(function (response) {
			  if (response.ok) {
				  document.dispatchEvent(new CustomEvent('eurus:cart:reload', { bubbles: true }));
				  refreshCart();
			  }
			});
	}
	function refreshCart() {
	   jQuery.getJSON('/cart.js', function(cart) {
			let cartData = cart.items;
			document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
			document.dispatchEvent(new CustomEvent('cart:refresh', {
				bubbles: true,
				 detail: cartData
			})); 
	   });
	}
	function nextClick() {
		var num = this.id.substr(1)
		process(num);
	}
	function process (num) {
			
		document.getElementById('Q'+num).style.display = 'none';
		if (num < 4) {
			document.getElementById('Q'+(1+parseInt(num))).style.display = 'block';
		} else {
			document.getElementsByClassName('QuizzBack')[0].style.display = 'none';
			let res = document.getElementById('Result');
			res.style.display = 'block';
			res.scrollIntoView();
		}
		var sum = 0;
		for (var i=1; i<5;i++) { 
			var r = document.getElementsByName('R'+i); 
			for (var j=0; j<r.length; j++) { 
				if (r[j].checked) { sum+=parseInt(r[j].value); break; }
			}
		}
		if (num>=4) {
			history.pushState({sum: sum }, '');
		}
		for (i=0; i<masks.length; i++) {
			if ((masks[i][0] & sum)==sum) {
				for (j=1; j<5; j++) {
					var p = quizzProducts[masks[i][j]];
					document.getElementById('P'+j).innerHTML=names[masks[i][j]];
					document.getElementById('I'+j).src=p.image;
					document.getElementById('N'+j).innerHTML=p.title;
					document.getElementById('E'+j).innerHTML=(p.price/100).toFixed(0) + ' &#8364;';
					document.getElementById('C'+j).dataVariant=p.id;
					document.getElementById('L'+j).href = p.link; 
				}
				break;
			}
		}
	}
	for (var i=1; i<5;i++) { 
		var r = document.getElementsByName('R'+i); 
		for (var j=0; j<r.length; j++) { 
			r[j].addEventListener('click', radioClick);
		}
		document.getElementById('B'+i).addEventListener('click', nextClick);
		document.getElementById('C'+i).addEventListener('click', addToCart);
	}
	let links = document.querySelectorAll('a[href="#quizz"]');
	links.forEach(l=>{ l.addEventListener('click', (e) => {
		e.preventDefault();
		document.getElementById('Result').style.display = 'none';
		document.getElementsByClassName('QuizzBack')[0].style.display = 'block';
		document.getElementById('Q1').style.display = 'block';
	}); });
	if (history.state?.sum) {
		process(4);
	}
	if (window.location.href.endsWith('#test')) {
		var missing = Object.keys(names).filter(k=>!quizzProducts[k]).map(k=>names[k]);
		if (missing.length == 0) { window.alert('All ok'); }
		else { window.alert('Missing: ' + missing.join(', ')) }
	}
}